export const categoriesMainData = [
    {
        id: 1,
        name: 'Current Events & Politics'
    },
    {
        id: 2,
        name: 'Beauty & Health'
    },
    {
        id: 3,
        name: 'Lifestyle & Culture'
    },
    {
        id: 4,
        name: 'Aspiration'
    },
    {
        id: 5,
        name: 'Money/ Finances/ Education'
    },
    {
        id: 6,
        name: 'Food & Bevarage'
    },
    {
        id: 7,
        name: 'Love & Relationship'
    },
    {
        id: 8,
        name: 'Fashion'
    },
    {
        id: 9,
        name: 'Media Entertinment/ Technology'
    }

]

export const userLoginInfo = {
    email: 'test@gmail.com',
    password: '123456789',
    remember: true
}
// home data
export const categoriesMainDataHomeTeam = [
    {
        id: 1,
        name: 'Current Events & Politics'
    },
    {
        id: 2,
        name: 'Beauty & Health'
    },
    {
        id: 3,
        name: 'Lifestyle & Culture'
    },
    {
        id: 4,
        name: 'Aspiration'
    },
    {
        id: 5,
        name: 'Money/ Finances/ Education'
    },
    {
        id: 6,
        name: 'Food & Bevarage'
    }

]
export const homeSidebar = [
    {
        id: 1,
        img: `/images/home/sidebar/img1.png`,
        section: "Media/ Entertainment/ Technology",
        category: "women 25-34, w kids",
        video: 'a',
        post: '',
        audio: ''
    },
    {
        id: 2,
        img: `/images/home/sidebar/img2.png`,
        section: "Media/ Entertainment/ Technology",
        category: "women 25-34, w kids",
        video: '',
        post: 'https://www.google.com/',
        audio: ''
    },
    {
        id: 3,
        img: `/images/home/sidebar/img1.png`,
        section: "Media/ Entertainment/ Technology",
        category: "women 25-34, w kids",
        video: '',
        post: '',
        audio: 'c'
    },
    {
        id: 4,
        img: `/images/home/sidebar/img2.png`,
        section: "Aspiration",
        category: "women 25-34, w kids",
        video: '',
        post: '',
        audio: ''
    }
]

export const homeSliderMonth = [
    {
        id: 1,
        img: `/images/home/month/img1.png`,
        section: "Aspiration",
        category: "women 18-24",
        video: '',
        post: 'https://www.google.com/',
        audio: ''
    },
    {
        id: 2,
        img: `/images/home/month/img2.png`,
        section: "Aspiration",
        category: "Women 34-33, w/o kids",
        video: '',
        post: '',
        audio: ''
    },
    {
        id: 3,
        img: `/images/home/month/img3.png`,
        section: "Aspiration",
        category: "women 18-24",
        video: '',
        post: '',
        audio: ''
    },
    {
        id: 4,
        img: `/images/home/month/img2.png`,
        section: "Media Entertainment",
        category: "Women 34-33, w/o kids",
        video: '',
        post: '',
        audio: 'c'
    },
    {
        id: 5,
        img: `/images/home/month/img1.png`,
        section: "Aspiration",
        category: "women 18-24",
        video: '',
        post: '',
        audio: 'd'
    },
    {
        id: 6,
        img: `/images/home/month/img2.png`,
        section: "Aspiration",
        category: "Women 34-33, w/o kids",
        video: '',
        post: '',
        audio: ''
    }

]

export const personaHomeList = [
    {
        id: 1,
        name: 'Keyshanna',
        age: '18',
        img: `/images/home/persona/persona1.png`,
        status: 'Single',
        children: 'No kids',
        country: 'Los Angeles',
    },
    {
        id: 2,
        name: 'Gabrielle',
        age: '38',
        img: `/images/home/persona/persona2.png`,
        status: 'Married',
        children: '6-year-old twin boys',
        country: 'Oakland',
    },
    {
        id: 3,
        name: 'Tarana',
        age: '49',
        img: `/images/home/persona/persona3.png`,
        status: 'Married',
        children: '12-year-old son, 16-year-old daughter',
        country: 'NY',
    },
    {
        id: 4,
        name: 'Nina',
        age: '21',
        img: `/images/home/persona/persona4.png`,
        status: 'Single',
        children: 'no kids',
        country: 'Orange County',
    }
]
// home data end